import $ from "jquery";
import Cookies from "js-cookie";

const $cookiesEl = $(".cookies");
const $cookiesBar = $(".cookies__bar");
const $cookiesConsent = $(".cookies-consent");
const $cookiesConsentCustom = $(".cookies-consent-custom");
const $cookiesDecline = $(".cookies-decline");
const $cookiesCheckAll = $(".cookies-check-all");

const acknowledgeCookies = (type = "checked") => {
  const categories = [];

  if (type === "all") {
    checkAll();
  }

  if (type === "none") {
    unCheckAll();
  }

  $cookiesEl.find(".checkbox-switch__input:checked").each(function () {
    for (const category of $(this).data("category").split(",")) {
      categories.push(category);
    }
  });

  Cookies.set("cookies_consent", categories.join(","), { expires: 20 });

  const defaultConsent = {
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    analytics_storage: "denied",
    functionality_storage: "denied",
    personalization_storage: "denied",
    security_storage: "granted",
  };

  for (const category of categories) {
    if (defaultConsent[category] !== undefined) {
      defaultConsent[category] = "granted";
    }
  }

  gtmUpdateConsent(defaultConsent);
};

const checkAll = () =>
  $cookiesEl
    .find(".checkbox-switch__input")
    .filter(function () {
      return !this.disabled;
    })
    .prop("checked", true);

const unCheckAll = () =>
  $cookiesEl
    .find(".checkbox-switch__input")
    .filter(function () {
      return !this.disabled;
    })
    .prop("checked", false);

if (Cookies.get("cookies_consent") === undefined) {
  $cookiesBar.slideUp(0).slideDown(300).addClass("cookies__bar--active");
}

$cookiesConsent.on("click", () => {
  acknowledgeCookies("all");
  $cookiesBar.removeClass("cookies__bar--active").slideUp(300);
});
$cookiesCheckAll.on("click", () => {
  acknowledgeCookies("all");
  $cookiesBar.removeClass("cookies__bar--active").slideUp(300);
});
$cookiesDecline.on("click", () => {
  acknowledgeCookies("none");
  $cookiesBar.removeClass("cookies__bar--active").slideUp(300);
});
$cookiesConsentCustom.on("click", () => {
  acknowledgeCookies();
  $cookiesBar.removeClass("cookies__bar--active").slideUp(300);
});
